import React from "react"

import NAVIGATION_DATA from "content/categories.json"
import { slugify } from "utils"
import { BackgroundImage, CategoryItems, Content } from "./styles"

const NotFoundPageContent = () => (
  <Content id='content'>
    <BackgroundImage
      baseUrl="https://mindbodygreen-res.cloudinary.com/image/upload/404b_xjsvss.png"
      title="Error 404"
      images={[
        {
          screenSize: 768,
          transforms:
            "g_auto,c_fill,h_800,w_1440/e_gradient_fade:30,y_-0.7,b_black/q_90,fl_lossy,f_auto",
        },
        {
          transforms:
            "g_auto,c_fill,h_420,w_724/e_gradient_fade:30,y_-0.7,b_black/q_90,fl_lossy,f_auto",
        },
      ]}
    />
    <h1>404</h1>
    <p>
      Nama-stay chill. The page you&apos;re looking for doesn&apos;t exist, but we&apos;ve got
      plenty more inspiration below.
    </p>
    <CategoryItems>
      {NAVIGATION_DATA.map(({ category }) => (
        <a href={`/${slugify(category)}`} title={category} key={category}>
          {category}
        </a>
      ))}
    </CategoryItems>
  </Content>
)

export default NotFoundPageContent
